import { render, staticRenderFns } from "./PatternCategory.vue?vue&type=template&id=741e3126&scoped=true&"
import script from "./PatternCategory.vue?vue&type=script&lang=js&"
export * from "./PatternCategory.vue?vue&type=script&lang=js&"
import style0 from "./PatternCategory.vue?vue&type=style&index=0&id=741e3126&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741e3126",
  null
  
)

export default component.exports